import {
  Grid,
  IconButton,
  LinearProgress,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { GridLoadingOverlay } from "@material-ui/data-grid";
import {
  ChevronLeft,
  ChevronRight,
  ExpandMore,
  FirstPage,
  LastPage,
} from "@material-ui/icons";
import { connect } from "react-redux";

import {
  searchPerPage,
  searchPage,
} from "../redux/OrderHistory/historyActionCreators";
import Store from "../redux/Store";

const CustomPagination = () => {
  const { historyReducer } = Store.getState();
  const { ordersHistory } = Store.getState().OrderReducer;
  const { perPage, page } = historyReducer;
  let start = perPage * page;
  const lastPage = page >= Math.ceil(ordersHistory.length / perPage) - 1;
  let validPageNumber = Number((ordersHistory.length / perPage).toFixed());

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      style={{
        margin: "auto",
        backgroundColor: "white",
        width: "100%",
        zIndex: 100,
      }}
    >
      <Grid item xs={2} container>
        <Typography variant="subtitle2">
          نمایش {perPage * page} الی{" "}
          {!lastPage ? perPage * page + perPage : ordersHistory.length} از{" "}
          {ordersHistory.length}
        </Typography>
      </Grid>

      <Grid item xs={2} container alignItems="center" justifyContent="center">
        <Typography variant="subtitle2">نمایش</Typography>
        <TextField
          select
          value={perPage}
          variant="outlined"
          size="small"
          SelectProps={{ IconComponent: ExpandMore }}
          onChange={(e) => {
            Store.dispatch(searchPerPage(e.target.value));

            Store.dispatch(searchPage(0));
          }}
          style={{ margin: "0 10px" }}
        >
          {options.map((item, i) => (
            <MenuItem key={i} value={item}>
              {item}
            </MenuItem>
          ))}
        </TextField>

        <Typography variant="subtitle2">ردیف</Typography>
      </Grid>
      <Grid item container style={{ width: 365 }}>
        <IconButton
          disabled={page === 0}
          color="primary"
          onClick={() => {
            Store.dispatch(searchPage(0));
          }}
        >
          <LastPage />
        </IconButton>
        <IconButton
          disabled={page === 0}
          color="primary"
          onClick={() => {
            Store.dispatch(searchPage(page - 1));
          }}
        >
          <ChevronRight fontSize="medium" />
        </IconButton>
        <IconButton
          onClick={() => Store.dispatch(searchPage(0))}
          color="primary"
          style={{
            marginLeft: 15,
            fontSize: 18,
          }}
        >
          1
        </IconButton>
        <IconButton
          color="primary"
          disabled={perPage - start >= ordersHistory.length}
          style={{
            marginLeft: 15,
            fontSize: 18,
          }}
          onClick={() => Store.dispatch(searchPage(1))}
        >
          2
        </IconButton>
        <IconButton
          color="primary"
          disabled={validPageNumber <= 2}
          style={{
            marginLeft: 10,
            fontSize: 18,
          }}
          onClick={() => Store.dispatch(searchPage(2))}
        >
          3
        </IconButton>

        <IconButton
          disabled={page >= Math.ceil(ordersHistory.length / perPage) - 1}
          color="primary"
          onClick={() => {
            Store.dispatch(searchPage(page + 1));
          }}
        >
          <ChevronLeft fontSize="medium" />
        </IconButton>
        <IconButton
          color="primary"
          disabled={page >= Math.ceil(ordersHistory.length / perPage) - 1}
          style={{
            marginLeft: 10,
            fontSize: 18,
          }}
          onClick={() => {
            Store.dispatch(
              searchPage(
                Math.max(0, Math.ceil(ordersHistory.length / perPage) - 1)
              )
            );
          }}
        >
          <FirstPage />
        </IconButton>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (props) => {
  const { OrderReducer, historyReducer } = props;
  const { ordersHistory } = OrderReducer;
  return { ordersHistory, historyReducer };
};
export default connect(mapStateToProps)(CustomPagination);

export function CustomLoadingOverlay() {
  return (
    <GridLoadingOverlay>
      <div style={{ position: "relative", top: 0, width: "100%" }}>
        <LinearProgress />
      </div>
    </GridLoadingOverlay>
  );
}

const options = [3, 10, 25, 50, 100];
